import type { Vehicle } from "../types/index";

export const locations = [
  "Auckland",
  "Christchurch",
  "Queenstown",
  "Dunedin",
  "Wellington",
];

export const vehicles: Vehicle[] = [
  {
    id: 1,
    name: "Sedan",
    type: "car",
    description:
      "Compact and fuel efficient for city exploration and road trips. Perfect for couples or small groups.",
    specs: {
      passengers: 5,
      luggage: 2,
      transmission: "Automatic",
      fuel: "Petrol",
    },
    pricePerDay: 65,
    images: ["/assets/sedan.jpg"],
    features: [
      "GPS",
      "Air Conditioning",
      "Bluetooth",
      "USB Charging",
      "Cruise Control",
    ],
    availability: true,
  },
  {
    id: 2,
    name: "SUV",
    type: "car",
    description:
      "Versatile mid sized SUV, perfect for families and groups exploring diverse terrains.",
    specs: {
      passengers: 7,
      luggage: 4,
      transmission: "Automatic",
      fuel: "Petrol",
    },
    pricePerDay: 120,
    images: ["/assets/suv.jpg"],
    features: [
      "GPS",
      "4x4 Capability",
      "Apple CarPlay",
      "Android Auto",
      "Lane Assist",
    ],
    availability: true,
  },
  {
    id: 3,
    name: "MPV",
    type: "car",
    description:
      "Multi-purpose vehicle with spacious interior and flexible seating, ideal for families with children or larger groups.",
    specs: {
      passengers: 8,
      luggage: 5,
      transmission: "Automatic",
      fuel: "Petrol/Hybrid",
    },
    pricePerDay: 110,
    images: ["/assets/vellfire-harbour-bridge-1.jpg"],
    features: [
      "GPS",
      "Sliding Doors",
      "Rear Entertainment",
      "Bluetooth",
      "Extra Storage",
    ],
    availability: true,
  },
  {
    id: 4,
    name: "Van",
    type: "car",
    description:
      "Practical van perfect for larger tour groups with plenty of luggage space.",
    specs: {
      passengers: 12,
      luggage: 8,
      transmission: "Automatic",
      fuel: "Diesel",
    },
    pricePerDay: 175,
    images: ["/assets/van.jpg"],
    features: [
      "GPS",
      "Air Conditioning",
      "Sliding Doors",
      "High Roof",
      "Reversing Camera",
    ],
    availability: true,
  },

  {
    id: 6,
    name: "2-Berth Campervan",
    type: "motorhome",
    description:
      "Compact and easy to drive campervan perfect for couples seeking freedom and flexibility.",
    specs: {
      passengers: 2,
      luggage: 2,
      transmission: "Automatic",
      fuel: "Diesel",
    },
    pricePerDay: 145,
    images: ["/assets/549F1A97-F6E3-401B-B65D-848A2E458D0A_1_201_a.jpeg"],
    features: [
      "Kitchen",
      "Bed",
      "Solar Power",
      "Water Tank",
      "Toilet",
      "Shower",
    ],
    availability: true,
  },
  {
    id: 7,
    name: "4-Berth Motorhome",
    type: "motorhome",
    description:
      "Spacious motorhome ideal for small families or groups of friends travelling together.",
    specs: {
      passengers: 4,
      luggage: 4,
      transmission: "Automatic",
      fuel: "Diesel",
    },
    pricePerDay: 185,
    images: ["/assets/B2B18571-5E09-4946-9C8B-22333238222A_1_201_a.jpeg"],
    features: [
      "Full Kitchen",
      "2 Bedrooms",
      "Dining Area",
      "Bathroom",
      "Air Conditioning",
      "Generator",
    ],
    availability: true,
  },
  {
    id: 8,
    name: "6-Berth Motorhome",
    type: "motorhome",
    description:
      "Luxurious large motorhome with all amenities for extended family trips or group tours.",
    specs: {
      passengers: 6,
      luggage: 6,
      transmission: "Automatic",
      fuel: "Diesel",
    },
    pricePerDay: 245,
    images: ["/assets/motorhome-sprinter.jpg"],
    features: [
      "Premium Kitchen",
      "3 Separate Bedrooms",
      "Living Room",
      "Full Bathroom",
      "Washer/Dryer",
      "Satellite TV",
    ],
    availability: true,
  },
];
